module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ../local_modules/react-infinite-scroller/index.js
// module id = 7735
// module chunks = 0